module.exports = __webpack_public_path__ + "media/components/assets/icons/check/check_square-8d3c8ae9384ebd39695347993f488f60.svg";